module.exports = __webpack_public_path__ + "img/6V.ccfac68b.png";